/*
 * FOOTER
 */
import React from 'react';
import { useEffect } from 'react';
import CTA from '@/components/shared/CTA';
import Menu from '@/components/shared/Menu';
import '@/styles/components/feedback.scss';
import '@/styles/components/footer.scss';

// Year
const footerDate: Date = new Date();
const footerYear: number = footerDate.getFullYear();

const Footer: React.FC = () => {
    useEffect( () => {
        // Add scripts to footer
        const footer: HTMLElement | null = document.getElementById( 'af-footer' );
        if ( footer ) {
            const newScript1 = document.createElement( 'script' );
            newScript1.setAttribute( 'src', 'https://mktdplp102cdn.azureedge.net/public/latest/js/form-loader.js?v=1.84.2007' );
            footer.insertAdjacentElement( 'afterend', newScript1 );

            const newScript2 = document.createElement( 'script' );
            newScript2.setAttribute( 'src', 'https://mktdplp102cdn.azureedge.net/public/latest/js/ws-tracking.js?v=1.84.2007' );
            footer.insertAdjacentElement( 'afterend', newScript2 );
        }
        const signupBtn = document.getElementById( 'footer-cta' );
        if ( signupBtn ) {
            signupBtn.addEventListener( 'click', function( e ) {
                e.preventDefault();
                const signupAside = document.getElementById( 'newsletter-signup' );
                if ( signupAside ) {
                    signupAside.classList.add( 'open' );
                }
            } );
        }
        const signupClose = document.getElementById( 'signup-close' );
        if ( signupClose ) {
            signupClose.addEventListener( 'click', function( e ) {
                e.preventDefault();
                const signupAside = document.getElementById( 'newsletter-signup' );
                if ( signupAside ) {
                    signupAside.classList.remove( 'open' );
                }
            } );
        }
    }, [] );
    return(
        <>
        <footer id="af-footer">
            <section id="af-footer-top">
                <div className="container">
                    <Menu name="footer-nav" />
                    <CTA url="#" modal={ false } id="footer-cta"><span>Sign Up for Our Newsletter</span></CTA>
                </div>
            </section>
            <section id="af-footer-bottom">
                <div className="container">
                    <p className="footer-address">Astraea Foundation &bull; 421 8th Ave #2752, New York, NY 10116-2752 &bull; Phone +1 (212) 529-8021</p>
                    <p className="footer-year">© { footerYear } Astraea Lesbian Foundation for Justice. All Rights Reserved.<br /> Astraea Foundation, Inc. is a 501(c)(3). All donations are tax deductible. EIN #13-2992977</p>
                </div>        
            </section>
            { /* TODO: Cookie Consent */ }
        </footer>
        <aside id="newsletter-signup">
            <button id="signup-close"><span>Close</span></button>
            <div id="signup-inner-wrapper">
                <div data-form-block-id="9ed261a9-da42-ef11-8409-000d3a5b18f0"></div>
                <div id="dADrgZ99wiLhDNF6WRDsWXp9XaT2HkfqL2nmAoTpnVjY"></div>
                <div className="d365-mkt-config" style={ { display: 'none' } } data-website-id="ADrgZ99wiLhDNF6WRDsWXp9XaT2HkfqL2nmAoTpnVjY" data-hostname="ec419243c0e548d8be1b6664e642c1f2.svc.dynamics.com"></div>
            </div>
        </aside>
        </>
    );
};
export default Footer;